import { Roles } from 'src/pages/auth/constants/AuthConstants';
import { User } from 'src/reducers/commonSlice';
import { ViewType } from '../constants';
import { NavigateFunction, Routes } from 'react-router-dom';
import APP_ROUTES from 'src/layout/Routes';
import { IAgentAvaibilityDatum, IViewType } from '../constants/types';

export const setViewType = (user: User): IViewType => {
  const { roles } = user;
  if (!roles?.length) return null;
  // there are changes that user can have multiple roles both team lead and senior team lead
  // giving first priorty to senior team lead
  if (roles.indexOf(Roles.ROLE_SENIOR_TEAM_LEAD) >= 0) {
    return ViewType.SENIOR_TEAM_LEAD;
  }
  if (roles.indexOf(Roles.ROLE_TEAM_LEAD) >= 0) {
    return ViewType.TEAM_LEAD;
  }
  return null;
};

export const isAllowedToView = (user: User): boolean => {
  const { roles, naviUser } = user;
  if (!naviUser) return false;
  if (!roles?.length) return false;
  if (roles.indexOf(Roles.ROLE_TEAM_LEAD) >= 0 || roles.indexOf(Roles.ROLE_SENIOR_TEAM_LEAD) >= 0)
    return true;
  return false;
};

export const redirectToAllCases = (navigate: NavigateFunction) => {
  navigate(APP_ROUTES.CASES.path);
};

export const updateQueryParamWithStack = (navigate: NavigateFunction) => {
  navigate(APP_ROUTES.CASES.path);
};

export const getActiveHours = (data: IAgentAvaibilityDatum) => {
  const percentage = (data?.activeDurationInMinutes / data?.totalDurationInMinutes) * 100;
  const correctedPercentage = Math.min(percentage, 100);
  return correctedPercentage;
};
